import { render, staticRenderFns } from "./loadAmbiente.vue?vue&type=template&id=9f45721a&scoped=true&"
var script = {}
import style0 from "./loadAmbiente.vue?vue&type=style&index=0&id=9f45721a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f45721a",
  null
  
)

export default component.exports